import React from 'react';
import Navigation from './navigation';
import Footer from './footer';
import cn from 'classnames';
import SEO from './seo';
import CookieConsent from 'react-cookie-consent';

const Layout = ({ title, className, children, parentClassName, location }) => {
  return (
    <div className={cn('flex flex-col w-full min-h-screen relative font-inter bg-white', parentClassName)}>
      <SEO title={title} />
      <Navigation location={location} />
      <div className={className}>{children}</div>
      <div className='mt-auto pt-16 bg-white z-10'>
        <Footer location={location} />
      </div>
      <CookieConsent
        disableStyles={true}
        location='bottom'
        cookieName='gatsby-gdpr-google-analytics'
        buttonText={'Acceptera'}
        containerClasses='w-full bg-white lg:bg-opacity-50 hover:bg-opacity-100 transition-all duration-200 border-black border border-l-0 border-b-0 shadow lg:w-1/2 xl:w-2/5 fixed py-4 flex items-center justify-between px-4 text-base md:text-lg lg:rounded-tr shadow z-10'
        buttonClasses='btn-outline ml-4 rounded'>
        Denna webbsida använder cookies för att förbättra användarupplevelsen.
      </CookieConsent>
    </div>
  );
};

export default Layout;
